import { Permission } from '@cims-online/shared'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import {
  DSAction,
  useActionsTableContext,
} from '../../../../ActionsTableContext'
import { useCreateDsActionMutation } from 'schema'
import CreateEditFormItems from '../../components/CreateEditFormItems'
import { CreateFormItemsValues } from '../../components/CreateEditFormItems/types'
import { useProjectContext } from 'context/ProjectContext'

export function useCreate(): CreateHeaderActionOptions<DSAction> {
  const { projectId } = useProjectContext()
  const { refetch, fetching } = useActionsTableContext()
  const [create] = useCreateDsActionMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createDSAction: {
        action: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    loading: fetching,
    entity: 'Action',
    permission: Permission.CreateDesignSubmittalAction,
    modal: {
      type: 'simple',
      body: <CreateEditFormItems />,
      onOk: async ({ name, description }: CreateFormItemsValues) => {
        await create({
          variables: { input: { projectId, name, description } },
        })
        refetch()
      },
    },
  }
}
